export default __webpack_public_path__ + "static/media/coinca II cuarto.19eca822.jpg";